// extracted by mini-css-extract-plugin
export default {"home":"home__dHsuy","expandingSection":"expandingSection__GHpq9","card":"card__oZKNw"};